<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import UiStatusPill from '@/Components/UI/UiStatusPill.vue'

const props = defineProps({ expiresAt: { type: [String, null], default: null } })
const { t } = useI18n()

const state = computed(() => {
  if (!props.expiresAt) return null
  const now = new Date()
  const exp = new Date(props.expiresAt)
  const days = Math.ceil((exp - now) / 86400000)
  if (days < 0)  return { tone: 'danger', label: t('licence.expired', 'Expired') }
  if (days <= 30) return { tone: 'warn',  label: t('licence.expires_in', { days }) }
  return { tone: 'ok', label: t('licence.valid', 'Valid') }
})
</script>

<template>
  <UiStatusPill v-if="state" :tone="state.tone" variant="soft" :label="state.label" />
</template>
